import React from "react";
import {text} from "../../constants/text";
import ImageBasic from "../Common/Image/ImageBasic";
import {formatCurrency} from "../../utils";

const ProductItem = ({product}) => {
    const {thumbnail, productName, price, variantTitle, quantity, subtotal} = product || {}
    return (
        <div
            className="flex justify-between items-center text-sm space-x-4 cursor-pointer p-4 border-b border-dashed border-gray-200 last:border-b-0">
            <div className="flex items-center space-x-4 w-full md:w-[60%]">
                <div className="min-w-20 h-20 relative">
                    <ImageBasic
                        src={thumbnail}
                        alt={productName}
                        className='w-20 h-20'
                    />
                </div>
                <div className="flex-1 text-sm">
                    <div className="font-medium">{productName}</div>
                    <div className="flex justify-between items-center mt-2">
                    <span
                        className="text-gray-500">{`${text.unitPrice}: ${formatCurrency(price)}đ`}</span>
                    </div>
                    <div className="text-gray-500">{`${text.type}: ${variantTitle}`}</div>
                    <div className='md:hidden text-gray-500 flex justify-between items-center'>
                        <div>{`${text.quantity}: ${quantity}`}</div>
                        <div
                            className='min-w-[50px] text-black text-right font-bold'>{`${formatCurrency(subtotal)}đ`}</div>
                    </div>
                </div>
            </div>
            <div className='hidden md:block'>{`${text.quantity}: ${product.quantity}`}</div>
            <div className="hidden md:block text-center">
                <p className="font-bold min-w-[50px] text-right">
                    {`${formatCurrency(subtotal)}đ`}
                </p>
            </div>
        </div>
    );
};
export default ProductItem;